import { render } from "./footerComponent.vue?vue&type=template&id=5dccc714"
import script from "./footerComponent.vue?vue&type=script&lang=js"
export * from "./footerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__